import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Modal,
  ButtonToolbar,
  OverlayTrigger,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { ModalPartiesRadio } from "../ModalPartiesRadio";

import {
  checkPermision,
  dateDefault,
  formLabelsTheme,
  getValueType,
  iconError,
  optionsStatus,
  optionsStatusNG,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  useForceUpdate,
  validateDateFields,
  validatePost,
} from "../../../utility";
import SVG from "react-inlinesvg";
import Select from "react-select";
import {
  sortCaret,
  headerSortingClasses,
  toAbsoluteUrl,
} from "../../../../_metronic/_helpers";
import {
  selectPagination,
  selectUser,
} from "../../../modules/Auth/_redux/authRedux";

// MUI
import {
  fade,
  withStyles,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { red } from "@material-ui/core/colors";
// import { UserCreate } from "./UserCreate";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import {
  resetData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchReporting,
  selectReporting,
  fetchFile,
  fetchFileBlob,
} from "../reportingSlice";
import { ReportTable } from "./ReportTable";

import { useStyles, useStylesReddit } from "../../../utility";

import { ModalColorRadio } from "../../modalfilter/ModalColorRadio";
import { ModalProductRadio } from "../../modalfilter/ModalProductRadio";
import { ModalModelRadio } from "../../modalfilter/ModalModelRadio";
import { ModalClientRadio } from "../ModalClientRadio";
import {
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
} from "../../businessParameter/businessParameterSlice";
import { Autocomplete } from "@material-ui/lab";
import { FormHelperText } from "@material-ui/core";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const ReportInboundPage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectReporting);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const paginationSet = useSelector(selectPagination);
  const forceUpdate = useForceUpdate();

  const dataService = useSelector(selectParameter);
  const dataJobType = useSelector(selectParameter2);

  const [btnHideFilter, setBtnHideFilter] = useState(false);
  const [getDataDealer, setGetDataDealer] = useState(false);
  const [showParty, setShowParty] = useState(false);
  const [partyType, setPartyType] = useState("");
  const [partyTypeTitle, setPartyTypeTitle] = useState("");


  console.log(data, "data");

  useEffect(() => {
    dispatch(resetData());
  }, [dispatch]);

  // Fungsi untuk mengubah nilai btnHide antara true dan false
  const toggleBtnHideFilter = () => {
    setBtnHideFilter(!btnHideFilter);
  };

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await dispatch(
        fetchParameter({
          paramgroup_code: "SERVICE_CLASS",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter2({
          paramgroup_code: "JOB_TYPE",
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  const [formValues, setFormValues] = useState({
    client_name: {
      value: "",
      error: false,
      required: "Y",
    },
    job_date_start: {
      value: "",
      error: false,
      required: "N",
    },
    job_date_end: {
      value: "",
      error: false,
      required: "N",
    },
    job_type: {
      value: "",
      error: false,
      required: "N",
    },
    etd_start: {
      value: "",
      error: false,
      required: "N",
    },
    etd_end: {
      value: "",
      error: false,
      required: "N",
    },
    eta_start: {
      value: "",
      error: false,
      required: "N",
    },
    eta_end: {
      value: "",
      error: false,
      required: "N",
    },
    service_class: {
      value: "",
      error: false,
      required: "N",
    },
    shipper: {
      value: "",
      error: false,
      required: "N",
    },
  });

  const handleSearch = async () => {
    if (!validatePost(formValues, setFormValues)) {
      return;
    }

    const dateFields = ["job_date", "etd", "eta"];

    const dateValidationResult = validateDateFields(formValues, dateFields);
    if (dateValidationResult) {
      return showErrorDialog(dateValidationResult);
    }
    let params = {
      pageNo: 1,
      pageSize: paginationSet,
      reportType: "Inbound",
      Client: formValues.client_name.value,
      start_Job_Date: formValues.job_date_start.value,
      end_Job_Date: formValues.job_date_end.value,
      job_type: formValues.job_type.value,
      start_ETD: formValues.etd_start.value,
      end_ETD: formValues.etd_end.value,
      start_ETA: formValues.eta_start.value,
      end_ETA: formValues.eta_end.value,
      Service_Class: formValues.service_class.value,
      Shipper: formValues.shipper.value,
    };

    fields.forEach((item) => {
      params[item.params] = item.value;
    });

    try {
      const response = await dispatch(fetchReporting(params));
      if (response.payload.data.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let params = {
        pageNo: page,
        pageSize: sizePerPage,
        reportType: "Inbound",
        Client: formValues.client_name.value,
        start_Job_Date: formValues.job_date_start.value,
        end_Job_Date: formValues.job_date_end.value,
        job_type: formValues.job_type.value,
        start_ETD: formValues.etd_start.value,
        end_ETD: formValues.etd_end.value,
        start_ETA: formValues.eta_start.value,
        end_ETA: formValues.eta_end.value,
        Service_Class: formValues.service_class.value,
        Shipper: formValues.shipper.value,
      };

      fields.forEach((item) => {
        params[item.params] = item.value;
      });

      try {
        const response = await dispatch(fetchReporting(params));
        if (response.payload.data.status === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
    }
  };

  const handleDownload = async () => {
    if (!validatePost(formValues, setFormValues)) {
      return;
    }
    const dateFields = ["job_date", "etd", "eta"];

    const dateValidationResult = validateDateFields(formValues, dateFields);
    if (dateValidationResult) {
      return showErrorDialog(dateValidationResult);
    }
    let params = {
      reportType: "Inbound",
      Client: formValues.client_name.value,
      start_Job_Date: formValues.job_date_start.value,
      end_Job_Date: formValues.job_date_end.value,
      job_type: formValues.job_type.value,
      start_ETD: formValues.etd_start.value,
      end_ETD: formValues.etd_end.value,
      start_ETA: formValues.eta_start.value,
      end_ETA: formValues.eta_end.value,
      Service_Class: formValues.service_class.value,
      Shipper: formValues.shipper.value,
    };

    fields.forEach((item) => {
      params[item.params] = item.value;
    });

    try {
      const response = await dispatch(fetchFile(params));
      if (response.payload.status === 200) {
        showSuccessDialog(response.payload.data.message);
      } else {
        showErrorDialog(response.payload.data.message);
        console.log("else");
      }
    } catch (error) {
      console.log("catch");
      showErrorDialog(error.message);
    }
  };

  // Parameter

  const [typeOptions, setTypeOptions] = useState([
    {
      id: "1",
      value: "Job_No",
      label: "Job No",
      show: "Y",
      editor: "text",
    },
    {
      id: "1",
      value: "vin",
      label: "VIN",
      show: "Y",
      editor: "text",
    },
    {
      id: "2",
      value: "von",
      label: "VON",
      show: "Y",
      editor: "text",
    },

    {
      id: "4",
      value: "Master_Code",
      label: "Master Code",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "Vehicle_Name",
      label: "Vehicle Name",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "Model_Code",
      label: "Model Code",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "Model_Name",
      label: "Model Name",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "Color_Code",
      label: "Color Code",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "Color_Name",
      label: "Color Name",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "engine_no",
      label: "Engine No.",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "Key_No",
      label: "Key No.",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "RCI_Result",
      label: "RCI Result",
      show: "Y",
      editor: "status_rci",
    },
    {
      id: "4",
      value: "Status",
      label: "Status",
      show: "Y",
      editor: "status",
    },
  ]);

  // paket filter

  const [btnHide, setBtnHide] = useState(false);

  const data_filter = typeOptions.filter((element) => element.show === "Y");

  const [fields, setFields] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  function handleRemarkChange(i, event) {
    const values = [...fields];
    values[i].value = event.target.value;
    setFields(values);
  }

  function handleAdd(i, event) {
    const values = [...fields];

    if (values[i].params === "") {
      showDialog("Please select filter first");
    } else {
      // update disabled field
      values[i].add = "Y";
      values[i].remove = "Y";
      setFields(values);
      //   change status show

      const result = typeOptions.map((item) => {
        if (item.value === values[i].params) {
          return { ...item, show: "N" };
        }
        return item;
      });

      setTypeOptions(result);

      const filteredShow = result.filter((item) => item.show === "Y");
      if (filteredShow.length <= 1) {
        setBtnHide(true);
      } else {
        setBtnHide(false);
      }

      //   push new paramater
      values.push({
        id: "",
        value: "",
        params: "",
        label: "",
        add: "N",
        editor: "text",
        remove: "N",
      });
      setFields(values);
    }
  }

  function handleRemove(i) {
    const values = [...fields];

    const result = typeOptions.map((item) => {
      if (item.value === values[i].params) {
        return { ...item, show: "Y" };
      }
      return item;
    });

    setTypeOptions(result);

    const filteredShow = result.filter((item) => item.show === "Y");
    if (filteredShow.length >= 1) {
      setBtnHide(false);
    } else {
      setBtnHide(true);
    }

    values.splice(i, 1);
    setFields(values);
  }

  const handleTypeChange = (i, event) => {
    const values = [...fields];
    values[i].params = event.value;
    values[i].id = event.id;
    values[i].editor = event.editor;
    values[i].label = event.label;
    values[i].value = "";
    setFields(values);
  };

  // paket filter bawah

  // modal filter
  const [showModel, setShowModel] = useState(false);
  const [showColor, setShowColor] = useState(false);
  const [showProduct, setShowProduct] = useState(false);
  const [showClient, setShowClient] = useState(false);
  const [getData, setGetData] = useState(false);
  const [getDataClient, setGetDataClient] = useState(false);

  const handleSelectChange = (i, e) => {
    if (e === null) {
      e = undefined;
      const values = [...fields];
      values[i].value = "";
      setFields(values);
    } else {
      const values = [...fields];
      values[i].value = e.value;

      setFields(values);
    }
  };

  const [fieldsFilter, setFieldsFilter] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const handleChangeJobType = (e, params) => {
    if (params === null) {
      setFormValues({
        ...formValues,
        ["job_type"]: {
          ...formValues["job_type"],
          value: "",
        },
      });
    } else {
      setFormValues({
        ...formValues,
        ["job_type"]: {
          ...formValues["job_type"],
          value: params.value,
        },
      });
    }
  };

  const handleChangeService = (e, params) => {
    if (params === null) {
      setFormValues({
        ...formValues,
        ["service_class"]: {
          ...formValues["service_class"],
          value: "",
        },
      });
    } else {
      setFormValues({
        ...formValues,
        ["service_class"]: {
          ...formValues["service_class"],
          value: params.value,
        },
      });
    }
  };

  const jobTypeOptions = dataJobType.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const serviceOptions = dataService.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const indexJobType = jobTypeOptions.findIndex(
    (obj) => obj.value === formValues.job_type.value
  );

  const index = serviceOptions.findIndex(
    (obj) => obj.value === formValues.service_class.value
  );

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <div>
        <Card>
          <CardBody>
            <Button
              className="btn btn-primary my-btn-primary-dark text-bold mb-5"
              onClick={toggleBtnHideFilter}
            >
              <span
                className="svg-icon svg-icon-md svg-icon-light"
                style={{ marginRight: "0px" }}
              >
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/New/SearchParameter.svg"
                  )}
                  className="mr-2"
                />
              </span>
              Search Parameter
            </Button>
            {btnHideFilter === true && (
              <>
                <div className="mb-5">
                  <ThemeProvider theme={formLabelsTheme}>
                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <RedditTextField
                              required
                              label="Client"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              value={formValues.client_name.value}
                              readOnly
                              error={formValues.client_name.error}
                              helperText={
                                formValues.client_name.error ? (
                                  <FormHelperText
                                    sx={{ mt: "5px", mb: "-10px" }}
                                  >
                                    {iconError} {"This field is required"}
                                  </FormHelperText>
                                ) : (
                                  ""
                                )
                              }
                            />
                          </Col>
                          <Col xs={1} sm={1} md={1} lg={1}>
                            <div>
                              <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                                <span
                                  className="svg-icon svg-icon-md svg-icon-light"
                                  onClick={() => {
                                    setShowClient(true);
                                    setGetDataClient(true);
                                  }}
                                >
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/Search.svg"
                                    )}
                                  />
                                </span>
                              </a>
                            </div>
                          </Col>
                          {formValues.client_name.value !== "" && (
                            <Col xs={1} sm={1} md={1} lg={1}>
                              <div
                                style={{ marginTop: "22px", cursor: "pointer" }}
                                onClick={() => {
                                  setFormValues({
                                    ...formValues,

                                    ["client_name"]: {
                                      ...formValues["client_name"],
                                      value: "",
                                    },
                                  });
                                }}
                              >
                                <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/x-square.svg"
                                    )}
                                  />
                                </span>
                              </div>
                            </Col>
                          )}
                        </Row>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <RedditTextField
                              label="Shipper"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              value={formValues.shipper.value}
                              readOnly
                            />
                          </Col>
                          <Col xs={1} sm={1} md={1} lg={1}>
                            <div>
                              <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                                <span
                                  className="svg-icon svg-icon-md svg-icon-light"
                                  onClick={() => {
                                    setShowParty(true);
                                    setPartyType("SHIPPER");
                                    setPartyTypeTitle("Shipper");
                                    setGetDataDealer(true);
                                  }}
                                >
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/Search.svg"
                                    )}
                                  />
                                </span>
                              </a>
                            </div>
                          </Col>
                          {formValues.shipper.value !== "" && (
                            <Col xs={1} sm={1} md={1} lg={1}>
                              <div
                                style={{ marginTop: "22px", cursor: "pointer" }}
                                onClick={() => {
                                  setFormValues({
                                    ...formValues,

                                    ["shipper"]: {
                                      ...formValues["shipper"],
                                      value: "",
                                    },
                                  });
                                }}
                              >
                                <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/x-square.svg"
                                    )}
                                  />
                                </span>
                              </div>
                            </Col>
                          )}
                        </Row>
                        <Row>
                          <Col xs={12} sm={3} md={4} lg={4}>
                            <RedditTextField
                              label="Job Date From"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              type="date"
                              size="small"
                              name="job_date_start"
                              fullWidth
                              onChange={handleChange}
                              value={formValues.job_date_start.value}
                            />
                          </Col>
                          <Col xs={1} sm={1} md={1} lg={1}>
                            <p className="text-center mt-5">To</p>
                          </Col>
                          <Col xs={12} sm={3} md={4} lg={4}>
                            <RedditTextField
                              label="Job Date Until"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              type="date"
                              size="small"
                              name="job_date_end"
                              fullWidth
                              onChange={handleChange}
                              value={formValues.job_date_end.value}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <Autocomplete
                              disablePortal
                              name="job_type"
                              options={jobTypeOptions}
                              getOptionLabel={(option) =>
                                option.label.toString()
                              }
                              onChange={handleChangeJobType}
                              value={jobTypeOptions[indexJobType]}
                              renderInput={(params) => (
                                <RedditTextField
                                  className={classes.margin}
                                  {...params}
                                  label="Job Type"
                                  id="reddit-input"
                                  size="small"
                                  fullWidth
                                  placeholder="Select"
                                  name="job_type"
                                />
                              )}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Row>
                          <Col xs={12} sm={3} md={4} lg={4}>
                            <RedditTextField
                              label="ETD From"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              type="date"
                              size="small"
                              name="etd_start"
                              fullWidth
                              onChange={handleChange}
                              value={formValues.etd_start.value}
                            />
                          </Col>
                          <Col xs={1} sm={1} md={1} lg={1}>
                            <p className="text-center mt-5">To</p>
                          </Col>
                          <Col xs={12} sm={3} md={4} lg={4}>
                            <RedditTextField
                              label="ETD Until"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              type="date"
                              size="small"
                              name="etd_end"
                              fullWidth
                              onChange={handleChange}
                              value={formValues.etd_end.value}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12} sm={3} md={4} lg={4}>
                            <RedditTextField
                              label="ETA From"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              type="date"
                              size="small"
                              name="eta_start"
                              fullWidth
                              onChange={handleChange}
                              value={formValues.eta_start.value}
                            />
                          </Col>
                          <Col xs={1} sm={1} md={1} lg={1}>
                            <p className="text-center mt-5">To</p>
                          </Col>
                          <Col xs={12} sm={3} md={4} lg={4}>
                            <RedditTextField
                              label="ETA Until"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              type="date"
                              size="small"
                              name="eta_end"
                              fullWidth
                              onChange={handleChange}
                              value={formValues.eta_end.value}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <Autocomplete
                              disablePortal
                              name="service_class"
                              options={serviceOptions}
                              getOptionLabel={(option) =>
                                option.label.toString()
                              }
                              onChange={handleChangeService}
                              value={serviceOptions[index]}
                              renderInput={(params) => (
                                <RedditTextField
                                  className={classes.margin}
                                  {...params}
                                  label="Service Class"
                                  id="reddit-input"
                                  size="small"
                                  fullWidth
                                  placeholder="Select"
                                  name="service_class"
                                  error={formValues.service_class.error}
                                  helperText={
                                    formValues.service_class.error ? (
                                      <FormHelperText
                                        sx={{ mt: "5px", mb: "-10px" }}
                                      >
                                        {iconError} {"This field is required"}
                                      </FormHelperText>
                                    ) : (
                                      ""
                                    )
                                  }
                                />
                              )}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </ThemeProvider>
                </div>
                {fields.map((field, idx) => {
                  return (
                    <div key={`${field}-${idx}`}>
                      <Form.Group as={Row}>
                        <Form.Label column sm={2} className="ml-4 pr-0">
                          {idx === 0 && <b>Advance Search</b>}
                        </Form.Label>

                        <Col sm={3} className="pl-0">
                          {fields[idx].add === "N" && (
                            <Select
                              // isClearable={true}
                              options={data_filter}
                              value={getValueType(field.params, typeOptions)}
                              placeholder="Select Field"
                              // onChange={handleTypeChange}
                              onChange={(e) => handleTypeChange(idx, e)}
                            />
                          )}
                          {fields[idx].add === "Y" && (
                            <Form.Control
                              type="text"
                              value={fields[idx].label}
                              disabled
                            />
                          )}
                        </Col>
                        <Col sm={3}>
                          {field.editor === "text" && (
                            <Form.Control
                              type="text"
                              placeholder="Enter text"
                              value={field.value || ""}
                              onChange={(e) => handleRemarkChange(idx, e)}
                            />
                          )}
                          {field.editor === "date" && (
                            <div>
                            <Form.Control
                              type="date"
                              placeholder="Enter Date"
                              value={field.value || ""}
                              onChange={(e) => handleRemarkChange(idx, e)}
                            />
                            <Form.Control
                              type="date"
                              placeholder="Enter Date"
                              value={field.value || ""}
                              onChange={(e) => handleRemarkChange(idx, e)}
                            />
                            </div>
                          )}
                          {field.editor === "status_rci" && (
                            <Select
                              isClearable={true}
                              options={optionsStatusNG}
                              value={getValueType(field.value, optionsStatusNG)}
                              placeholder="Select Status"
                              // onChange={handleTypeChange}
                              onChange={(e) => handleSelectChange(idx, e)}
                            />
                          )}
                          {field.editor === "status" && (
                            <Select
                              isClearable={true}
                              options={optionsStatus}
                              value={getValueType(field.value, optionsStatus)}
                              placeholder="Select Status"
                              // onChange={handleTypeChange}
                              onChange={(e) => handleSelectChange(idx, e)}
                            />
                          )}
                        </Col>
                        <Col sm={3} className=" m-0 p-0">
                          {field.params === "Model_Code" && (
                            <div
                              className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                              onClick={() => {
                                setShowModel(true);
                                setGetData(true);
                              }}
                            >
                              <span className="svg-icon svg-icon-md svg-icon-light">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/New/Search.svg"
                                  )}
                                />
                              </span>
                            </div>
                          )}
                          {field.params === "Color_Code" && (
                            <div
                              className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                              onClick={() => {
                                setShowColor(true);
                                setGetData(true);
                              }}
                            >
                              <span className="svg-icon svg-icon-md svg-icon-light">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/New/Search.svg"
                                  )}
                                />
                              </span>
                            </div>
                          )}
                          {field.params === "Master_Code" && (
                            <div
                              className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                              onClick={() => {
                                setShowProduct(true);
                                setGetData(true);
                              }}
                            >
                              <span className="svg-icon svg-icon-md svg-icon-light">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/New/Search.svg"
                                  )}
                                />
                              </span>
                            </div>
                          )}
                          {fields[idx].remove === "Y" && (
                            <div
                              className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                              onClick={() => handleRemove(idx)}
                            >
                              <span className="svg-icon svg-icon-md svg-icon-light">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/New/X.svg"
                                  )}
                                />
                              </span>
                            </div>
                          )}

                          {btnHide === false && fields.length - 1 === idx && (
                            <Button
                              className="mr-3"
                              variant="outline-primary"
                              onClick={(e) => handleAdd(idx, e)}
                            >
                              Add
                            </Button>
                          )}
                        </Col>
                      </Form.Group>
                    </div>
                  );
                })}

                <Row className="mt-6 justify-content-end">
                  <Button className="mr-3" onClick={handleDownload}>
                    <span
                      className="svg-icon svg-icon-md svg-icon-light"
                      style={{ marginRight: "0px" }}
                    >
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/New/XLS.svg")}
                      />
                    </span>
                    Download
                  </Button>

                  <Button
                    className="mr-3 btn-filter"
                    variant="primary"
                    onClick={handleSearch}
                  >
                    Search
                  </Button>
                </Row>
              </>
            )}

            <ReportTable
              data={data?.reportData || []}
              page={pageNo}
              sizePerPage={pageSize}
              totalSize={totalRecord}
              onTableChange={handleTableChange}
              loading={loading}
              handleSearch={handleSearch}
            />
          </CardBody>
        </Card>
      </div>

      <ModalClientRadio
        isOpen={showClient}
        setShow={setShowClient}
        setFormValues={setFormValues}
        formValues={formValues}
        setFields={setFieldsFilter}
        fields={fieldsFilter}
        getData={getDataClient}
        setGetData={setGetDataClient}
      />

      <ModalModelRadio
        isOpen={showModel}
        setShow={setShowModel}
        setFormValues={setFields}
        formValues={fields}
        setFields={setFieldsFilter}
        fields={fieldsFilter}
        getData={getData}
        setGetData={setGetData}
      />
      <ModalProductRadio
        isOpen={showProduct}
        setShow={setShowProduct}
        setFormValues={setFields}
        formValues={fields}
        setFields={setFieldsFilter}
        fields={fieldsFilter}
        getData={getData}
        setGetData={setGetData}
      />
      <ModalColorRadio
        isOpen={showColor}
        setShow={setShowColor}
        setFormValues={setFields}
        formValues={fields}
        setFields={setFieldsFilter}
        fields={fieldsFilter}
        getData={getData}
        setGetData={setGetData}
      />

      <ModalPartiesRadio
        isOpen={showParty}
        setShow={setShowParty}
        setFormValues={setFormValues}
        formValues={formValues}
        setFields={setFields}
        fields={fields}
        getData={getDataDealer}
        setGetData={setGetDataDealer}
        partyType={partyType}
        setPartyType={setPartyType}
        partyTypeTitle={partyTypeTitle}
        setPartyTypeTitle={setPartyTypeTitle}
      />
    </>
  );
};
